<template>
  <button class="copy-button" type="button" :aria-label="buttonLabel" @click="copyValue">
    {{ copied ? 'Copied' : 'Copy' }}
  </button>
</template>

<script>
import { computed, ref } from 'vue';

export default {
  name: 'CopyButton',
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'content'
    }
  },
  setup(props) {
    const copied = ref(false);
    let resetTimeout;
    const buttonLabel = computed(() => `Copy ${props.label}`);

    const copyValue = async () => {
      if (!props.value || !navigator.clipboard) {
        return;
      }

      await navigator.clipboard.writeText(props.value);
      copied.value = true;
      clearTimeout(resetTimeout);
      resetTimeout = setTimeout(() => {
        copied.value = false;
      }, 1400);
    };

    return { buttonLabel, copied, copyValue };
  }
};
</script>
